import React, {useEffect, useState, useRef, useCallback} from "react";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import Header from "../../components/Header";
import Button from "../../components/Button";
import Loader from "../../components/Loader";
import {API, processApiResponse} from "../../services/HttpHandler";

import {getCustomerSlotDetails} from "../../services/SessionStorage";

import "./style.scss";
import "../../components/Loader/style.scss";

import config from "config";

const CancelAppointments = () => {
  const updatedCustomerSlotDetails = useRef(getCustomerSlotDetails());
  const [loading, setLoading] = useState(false);
  const navigate = useRef(useNavigate());
  const {t} = useTranslation();
  const [error, setError] = useState("");
  const [cancelSuccess, setCancelSuccess] = useState(false);

  const handleClick = () => {
    navigate.current("/customer/displayAppointments");
  };

  const initiateCancel = useCallback(async (data) => {
    try {
      setError("");
      setLoading(true);
      let payloadData = {
        userId: data.userId,
      };
      const url = `${config.endPoints.cancelBookings}/${data.bookingId}`;
      let response = await API.put(url, payloadData);
      response = await processApiResponse(response);
      if (response) {
        setLoading(false);
        navigate.current("/customer/displayAppointments");
      } else {
        setCancelSuccess(false);
        setError(response.error);
      }
    } catch (error) {
      setCancelSuccess(false);
      setError(error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    async function checkCancel() {
      initiateCancel(updatedCustomerSlotDetails.current.cancelDetail);
    }
    checkCancel();
  }, [initiateCancel]);
  return loading ? (
    <div className="loader-container">
      <Loader />
    </div>
  ) : (
    <div className="selectMallStore-main-container">
      <Header title={t("slotbooked.title")} />
      {cancelSuccess ? (
        <div className="booking-cancel-status">
          <div className="add-bigger-calender"></div>
          <div className="cancel-success-text"> {t("cancel.success")}</div>
        </div>
      ) : (
        <div className="booking-cancel-status">
          <div className="add-cancel"></div>
          <div className="cancel-error-text"> {t("cancel.error")}</div>
        </div>
      )}

      <Button value={t("moveto.myappnt")} handleClick={handleClick} />
    </div>
  );
};

export default CancelAppointments;
